import React, { useState } from 'react';
import { Menu, Icon, Dropdown, Button } from 'antd';
import { Link } from 'react-router-dom';

const getTilte = (title, setAlitaState) => {
  setAlitaState({ stateName: "title", data: title })
  localStorage.setItem('title', title)
}

const renderMenuItem = (item, setAlitaState, t, allowedCodes) => {
  if (allowedCodes && !allowedCodes.includes(item.code)) return null;
  return (
    <Menu.Item key={item.key}
      onClick={() => { getTilte(item.title, setAlitaState) }}
    >
      <Link to={(item.route || item.key) + (item.query || '')} id={item.id}>
        {item.icon && <i className={item.icon + " icon"} />}
        <span className="nav-text">{t(item.title)}</span>
      </Link>
    </Menu.Item>
  );
};

const renderSubMenu = (item, setAlitaState, t, collapsed, allowedCodes) => {
  // If allowedCodes contains any sub-menu code, the parent menu is automatically opened
  const filteredSubs = item.subs ? item.subs.filter(sub => !allowedCodes || allowedCodes.includes(sub.code)) : [];
  const hasAllowedSub = filteredSubs.length > 0;
  // The parent menu code also needs to be checked for permission
  if (allowedCodes && !(allowedCodes.includes(item.code) || hasAllowedSub)) return null;
  if (!hasAllowedSub) return null;
  return (
    <Menu.SubMenu
      key={item.key}
      title={
        <div>
          <span>
            {item.icon && <i className={item.icon + " icon"} />}
            <span className="nav-text">{t(item.title)}</span>
          </span>
        </div>
      }
    >
      <Menu.ItemGroup title={<span>
        <span className='titleIcon'>{item.icon && <i className={item.icon + " icon"} />}</span>
        <span className='titleTitle'>{t(item.title)}</span>
      </span>} hidden={collapsed ? 1 : 0} className='close_title'>
      </Menu.ItemGroup>
      {filteredSubs.map(sub => renderMenuItem(sub, setAlitaState, t, allowedCodes))}
    </Menu.SubMenu>
  );
};

export default ({ menus, modules, serverConfig, userIDMode, userWizard, licenseRestriction, t, push, selectedKeys, openKeys, setAlitaState, showWizard, licenseMode, allowedCodes, ...props }) => {
  const [dragItems, setDragItems] = useState(menus);
  const divProps = Object.assign({}, props);
  delete divProps.clientHeight;
  const collapsed = props.collapsed;
  return (
    <div>
      {dragItems.map((item, index) => (
        <Menu key={item.key} {...divProps} selectedKeys={selectedKeys} openKeys={openKeys} subMenuOpenDelay={0.5}>
          {item.subs ?
            renderSubMenu(item, setAlitaState, t, collapsed, allowedCodes) :
            renderMenuItem(item, setAlitaState, t, allowedCodes)
          }
        </Menu>
      ))}
    </div>
  );
}
